import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function J({ langKey }: any) {
    const { useEffect, useState, useRouter, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(langKey || 'poweroceancollection');

    const items: any = [
        {
            title: t('secJ_item1_title'),
            desc: t('secJ_item1_desc'),
            img: require('@publicLocal/power-ocean/collection/pc/de/10_1.jpg'),
        },
        {
            title: t('secJ_item2_title'),
            desc: t('secJ_item2_desc'),
            img: require('@publicLocal/power-ocean/collection/pc/de/10_2.jpg'),
            reverse: true,
        },
        {
            title: t('secJ_item3_title'),
            desc: t('secJ_item3_desc'),
            img: require('@publicLocal/power-ocean/collection/pc/de/10_3.jpg'),
        },
    ];

    return (
        <div className={`power-ocean-collection-J ${css['power-ocean-collection-J']}`}>
            {items?.map((item: any, k: number) => (
                <div className={`item-box ${item?.reverse ? 'reverse' : ''}`} key={k}>
                    <div className="item-text">
                        <p className="item-title">{item?.title}</p>
                        <p className="item-desc">{item?.desc}</p>
                    </div>
                    <div className="img-box">
                        <NextImage src={item?.img} alt={item?.title} aria-label={item?.title} />
                    </div>
                </div>
            ))}
        </div>
    );
}
